import { CopyToClipboard } from "../../../../components";
import { Link } from "../../../../components/link";
import { IOC_TYPES_MAP, SEARCHABLE_IOC_TYPES } from "./consts";
import { getIOCSearchLink, refangIOCs } from "./utils";

type IOCType = keyof typeof IOC_TYPES_MAP;

type Props = {
  value: string;
  type: string;
};

const Name = ({ value, type }: Props) => {
  const iocType = IOC_TYPES_MAP[type as IOCType] ?? type;

  if (!SEARCHABLE_IOC_TYPES.includes(iocType?.toLowerCase()))
    return <div className="overflow-ellipsis">{value}</div>;

  const defangedIoc = refangIOCs(value);

  return (
    <div className="flex flex-gap-2">
      <Link
        className="overflow-ellipsis"
        to={getIOCSearchLink(iocType, defangedIoc)}
        variant="action"
      >
        {value}
      </Link>
      <CopyToClipboard value={value} />
    </div>
  );
};

export default Name;
